import { IntlProvider as RSuiteIntlProvider } from 'rsuite';
import es from 'rsuite/lib/IntlProvider/locales/es_ES';
import { formatDate } from '../../utils/time.util';

/**
 * React Suite Localization provider.
 *
 * @export
 *
 * @param {React.Element} children app root component.
 *
 * @returns {React.Element} application with localization applied.
 */
export default function IntlProvider({ children })
{
    return (
        <RSuiteIntlProvider locale={ es } >
            {children}
        </RSuiteIntlProvider>
    );
}
